import { Capacitor } from '@capacitor/core'
import { Platform } from '../types'

export const isNative = () => Capacitor.isNativePlatform()

/**
 * Detects the user's platform based on user agent and Capacitor context. 
 * On a mobile browser, this will return Platform.iOS or Platform.Android, not Platform.Web.
 * On an actual native app, this will return Platform.iOS or Platform.Android.
 * @returns {Platform} The detected platform
 */
export function getPlatform(): Platform {
    // First check if we're in a native app context
    if (isNative()) {
        const nativePlatform = Capacitor.getPlatform()
        return nativePlatform === 'ios' ? Platform.iOS : Platform.Android
    }

    // Only run browser detection on client
    if (process.client) {
        const userAgent = navigator.userAgent.toLowerCase()
        
        // iOS detection - include mobile Safari
        if (/iphone|ipad|ipod/.test(userAgent) || /iphone|ipad|ipod/.test(navigator.platform)) {
            return Platform.iOS
        }
        
        // Android detection - include Chrome mobile
        if (/android/.test(userAgent)) {
            return Platform.Android
        }
    }
    
    // Default to web
    return Platform.Web
} 